const actions = {

  PRODUCT_ADD_BEGIN: 'PRODUCT_ADD_BEGIN',
  PRODUCT_ADD_SUCCESS: 'PRODUCT_ADD_SUCCESS',
  PRODUCT_ADD_ERR: 'PRODUCT_ADD_ERR',


  PRODUCT_UPDATE_BEGIN: 'PRODUCT_UPDATE_BEGIN',
  PRODUCT_UPDATE_SUCCESS: 'PRODUCT_UPDATE_SUCCESS',
  PRODUCT_UPDATE_ERR: 'PRODUCT_UPDATE_ERR',

  PRODUCT_READ_BEGIN: 'PRODUCT_READ_BEGIN',
  PRODUCT_READ_SUCCESS: 'PRODUCT_READ_SUCCESS',
  PRODUCT_READ_ERR: 'PRODUCT_READ_ERR',


  PRODUCT_DELETE_BEGIN: 'PRODUCT_DELETE_BEGIN',
  PRODUCT_DELETE_SUCCESS: 'PRODUCT_DELETE_SUCCESS',
  PRODUCT_DELETE_ERR: 'PRODUCT_DELETE_ERR',




  productDeleteBegin: () => {
    return {
      type: actions.PRODUCT_DELETE_BEGIN,
    };
  },

  productDeleteSuccess: (data) => {
    return {
      type: actions.PRODUCT_DELETE_SUCCESS,
      data,
    };
  },

  productDeleteErr: (err) => {
    return {
      type: actions.PRODUCT_DELETE_ERR,
      err,
    };
  },







  productAddBegin: () => {
    return {
      type: actions.PRODUCT_ADD_BEGIN,
    };
  },

  productAddSuccess: (data) => {
    return {
      type: actions.PRODUCT_ADD_SUCCESS,
      data,
    };
  },

  productAddErr: (err) => {
    return {
      type: actions.PRODUCT_ADD_ERR,
      err,
    };
  },




  productReadBegin: () => {
    return {
      type: actions.PRODUCT_READ_BEGIN,
    };
  },

  productReadSuccess: (data) => {
    return {
      type: actions.PRODUCT_READ_SUCCESS,
      data,
    };
  },

  productReadErr: (err) => {
    return {
      type: actions.PRODUCT_READ_ERR,
      err,
    };
  },


  productUpdateBegin: () => {
    return {
      type: actions.PRODUCT_UPDATE_BEGIN,
    };
  },

  productUpdateSuccess: (data) => {
    return {
      type: actions.PRODUCT_UPDATE_SUCCESS,
      data,
    };
  },

  productUpdateErr: (err) => {
    return {
      type: actions.PRODUCT_UPDATE_ERR,
      err,
    };
  },


}

export default actions;
